import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { InsertExternalHoursDTO } from "../models/AditionalInfo/ValidExtraHourDTO";
import { AddPartToAssistanceDTO } from "../models/Assistance/AddPartToAssistanceDTO";
import { AssistanceAdditionalInfoUpdateDTO } from "../models/Assistance/AssistanceAdditionalInfoUpdateDTO";
import { AssistanceDescriptionUpdateDTO } from '../models/Assistance/AssistanceDescriptionUpdateDTO';
import { AssistanceDTO } from "../models/Assistance/AssistanceDTO";
import { AssistanceListDTO } from "../models/Assistance/AssistanceListDTO";
import { AssistanceStatusListDTO } from "../models/Assistance/AssistanceStatusListDTO";
import { AssistanceUpdateDTO } from "../models/Assistance/AssistanceUpdateDTO";
import { CreateAssistanceDTO } from "../models/Assistance/CreateAssistanceDTO";
import { DigitalSignatureDTO } from "../models/Assistance/DigitalSignatureDTO";
import { GetAssistanceByClientEquipmentDTO } from "../models/Assistance/GetAssistanceByClientEquipment";
import { GetAssistanceByDocumentDTO } from "../models/Assistance/GetAssistanceByDocumentDTO";
import { GetAssistanceDTO } from "../models/Assistance/GetAssistanceDTO";
import { GetDebtHoursDTO } from "../models/Assistance/GetDebtHoursDTO";
import { GetDocNumberDTO } from "../models/Assistance/GetDocNumberDTO";
import { GetExternalAssistancesDTO } from "../models/Assistance/GetExternalAssistancesDTO";
import { GetPaginatedDebtHoursDTO } from "../models/Assistance/GetPaginatedDebtHoursDTO";
import { GetPaginatedExternalAssistancesDTO } from "../models/Assistance/GetPaginatedExternalAssistancesDTO";
import { TechnicianDTO } from "../models/Assistance/TechnicianDTO";
import { UpdateClientInAssistanceAndEquipmentDTO } from "../models/Assistance/UpdateClientInAssistanceAndEquipmentDTO";
import { ValidDebtHourDTO } from "../models/Assistance/ValidDebtHourDTO";
import { ValidExternalHoursDTO } from "../models/Assistance/ValidExternalHoursDTO";
import { AssistancesTotalExecutionsDTO } from "../models/AssistanceExecution/AssistancesTotalExecutionsDTO";
import { CompleteAssistanceExecutionDTO } from "../models/AssistanceExecution/CompleteAssistanceExecutionDTO";
import { CreateAssistanceExecutionDTO } from "../models/AssistanceExecution/CreateAssistanceExecutionDTO";
import { DeleteExecutionDTO } from "../models/AssistanceExecution/DeleteExecutionDTO";
import { GetExecutionsByAssistanceDTO } from "../models/AssistanceExecution/GetExecutionsByAssistanceDTO";
import { StartAndEndExecutionDTO } from "../models/AssistanceExecution/StartAndEndExecutionDTO";
import { AssistancePartListDTO } from "../models/AssistanceParts/AssistancePartListDTO";
import { AssistancePartRequestWarehouse } from "../models/AssistanceParts/AssistancePartRequestWarehouseDTO";
import { PaginatedPartListDTO } from "../models/AssistanceParts/PaginatedPartListDTO";
import { AssistanceRecallDTO } from "../models/AssistanceRecall/AssistanceRecallDTO";
import { EditAssistanceRecallDTO } from "../models/AssistanceRecall/EditAssistanceRecallDTO";
import { AssistanceWarrantyDTO } from "../models/AssistanceWarranty/AssistanceWarrantyDTO";
import { EditAssistanceWarrantyDTO } from "../models/AssistanceWarranty/EditAssistanceWarrantyDTO";
import { AssistanceLoanEquipmentDTO } from "../models/Assistance/AssistanceLoanEquipmentDTO";
import { EditAssistanceLoanEquipmentDTO } from "../models/Assistance/EditAssistanceLoanEquipmentDTO";
import { GetAssistanceFromEquipmentDTO } from "../models/Equipment/GetAssistancesFromEquipmentDTO";
import { CreateFabricationDTO } from "../models/Fabrication/CreateFabricationDTO";
import { GetFileDTO } from "../models/File/GetFileDTO";
import { GetFileMetadataDTO } from "../models/File/GetFileMetadataDTO";
import { GetPaginatedFileListDTO } from "../models/File/GetPaginatedFileListDTO";
import { Parameter } from "../models/Parameter";
import { AssistanceProfitabilityDTO } from "../models/Profitability/AssistanceProfitabilityDTO";
import { AssistanceProfitabilityParametersDTO } from "../models/Profitability/AssistanceProfitabilityParametersDTO";
import { AddNewStatusDTO } from "../models/Status/AddNewStatusDTO";
import { GetStatusHistoryDTO } from "../models/Status/GetStatusHistoryDTO";
import { GetStatusPaginatedDTO } from "../models/Status/GetStatusPaginatedDTO";
import { StatusDTO } from "../models/Status/StatusDTO";
import { EditTechnicianFromAssistanceDTO } from "../models/Technician/EditTechnicianFromAssistanceDTO";
import { SearchBySubcontractorCompanyNameDTO } from "../models/Technician/SearchBySubcontractorCompanyNameDTO";
import { CanonSummaryDataDTO } from "../models/CanonSummary/CanonSummaryDataDTO";
import { APIService } from "./APIService";

export class AssistanceService {
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<AssistanceListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/getAll`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<AssistanceListDTO>(
        false,
        "Erro ao obter a informação das assistências",
        "",
        [],
        0
      );
    }
  }

  async GetAssistanceByDocNumber(
    data: GetDocNumberDTO
  ): Promise<MessagingHelper<GetAssistanceByDocumentDTO[] | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/getAssistanceByDocNumber`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );

      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para ir buscar informação da assistência pelo número de documento",
        null
      );
    }
  }

  async GetAssistancesByClientEquipmentFinalState(
    data: GetAssistanceByClientEquipmentDTO
  ): Promise<MessagingHelper<AssistanceDTO[] | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/getAssistancesByClientEquipmentByFinalState`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );

      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para ir buscar informação da assistência",
        null
      );
    }
  }

  async GetAssistanceIdByDoc(
    data: GetDocNumberDTO
  ): Promise<MessagingHelper<GetAssistanceByDocumentDTO[] | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/getAssistanceIdByDoc`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );

      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para ir buscar informação da assistência pelo número de documento",
        null
      );
    }
  }

  async Create(data: CreateAssistanceDTO): Promise<MessagingHelper<number>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/create`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para criar a assistência",
        0
      );
    }
  }

  async UpdateClientInAssistanceAndEquipment(data: UpdateClientInAssistanceAndEquipmentDTO): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().put(
        `${APIService.GetURL()}/Assistance/updateClientInAssistanceAndEquipment?id=${data.assistanceId}`,
        {
          ...data
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para atualizar o cliente na assistência e equipamento",
        null
      );
    }
  }


  async CreateInDbAndErp(
    data: CreateAssistanceDTO
  ): Promise<MessagingHelper<number>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/createInDbAndErp`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para criar a assistência",
        0
      );
    }
  }

  async GetById(id: number): Promise<MessagingHelper<AssistanceDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para ir buscar informação da assistencia",
        null
      );
    }
  }

  async Edit(
    assistance: AssistanceUpdateDTO
  ): Promise<MessagingHelper<AssistanceDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/edit`,
        { ...assistance },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação da assistencia",
        null
      );
    }
  }

  async EditAditionalInfo(
    assistance: AssistanceAdditionalInfoUpdateDTO
  ): Promise<MessagingHelper<AssistanceDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/editAditionalInfo`,
        { ...assistance },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação adicional da assistencia",
        null
      );
    }
  }

  async EditDescription(
    assistance: AssistanceDescriptionUpdateDTO
  ): Promise<MessagingHelper<AssistanceDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/editDescription`,
        { ...assistance },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação da assistencia",
        null
      );
    }
  }

  async Activate(
    assistanceId: number
  ): Promise<MessagingHelper<AssistanceDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/activate`,
        {
          assistanceId,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação da assistencia",
        null
      );
    }
  }

  async GetAssistance(
    assistance: GetAssistanceDTO
  ): Promise<MessagingHelper<AssistanceDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/getById`,
        {
          ...assistance,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para obter assistencia",
        null
      );
    }
  }

  async AddExecution(
    execution: CreateAssistanceExecutionDTO
  ): Promise<MessagingHelper<number[] | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/addExecution`,
        {
          ...execution,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para iniciar execução",
        null
      );
    }
  }

  async CompleteExecution(
    executionInfo: CompleteAssistanceExecutionDTO
  ): Promise<MessagingHelper<number[] | null>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/completeExecution`,
        {
          ...executionInfo,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para completar execução",
        null
      );
    }
  }

  async GetTechniciansWithOpenExecutionsByAssistanceId(
    assistanceId: number
  ): Promise<MessagingHelper<string>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/getTechniciansWithOpenExecutionsByAssistanceId/${assistanceId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para buscar os técnicos",
        ""
      );
    }
  }

  async GetExecutions(
    params: GetExecutionsByAssistanceDTO
  ): Promise<AssistancesTotalExecutionsDTO> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/getExecutions`,
        {
          ...params,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return {} as AssistancesTotalExecutionsDTO;
    }
  }

  async AddExecutionBackoffice(
    execution: StartAndEndExecutionDTO
  ): Promise<MessagingHelper<number | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/addExecutionBackoffice`,
        {
          ...execution,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para adicionar execução",
        null
      );
    }
  }

  async DeleteExecution(
    execution: DeleteExecutionDTO
  ): Promise<MessagingHelper<number | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/RemoveExecution`,
        {
          ...execution,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para remover a execução",
        null
      );
    }
  }

  async InsertDebtHours(
    DebtHours: ValidDebtHourDTO
  ): Promise<MessagingHelper<number | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/InsertDebtHours`,
        {
          ...DebtHours,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper(
        false,
        "Erro ao ligar ao servidor para registar as horas debitadas",
        null
      );
    }
  }

  async GetWorkshopTechnicians(): Promise<MessagingHelper<TechnicianDTO[]>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/technician/getWorkshopTechnicians`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<TechnicianDTO[]>(
        false,
        "Erro ao ligar ao servidor para obter os técnicos",
        []
      );
    }
  }

  async GetWorkshopTechniciansWithCode(): Promise<
    MessagingHelper<TechnicianDTO[]>
  > {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/technician/getWorkshopTechniciansWithCode`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<TechnicianDTO[]>(
        false,
        "Erro ao ligar ao servidor para obter os técnicos",
        []
      );
    }
  }

  async GetStatus(): Promise<MessagingHelper<AssistanceStatusListDTO[]>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/getStatus`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceStatusListDTO[]>(
        false,
        "Erro ao ligar ao servidor para obter os estados",
        []
      );
    }
  }

  async GetUsedParts(
    data: PaginatedPartListDTO
  ): Promise<PaginatedList<AssistancePartListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Part/GetPartsOfAssistance`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<AssistancePartListDTO>(
        false,
        "Erro ao obter a informação das peças usadas na assistência",
        "",
        [],
        0
      );
    }
  }

  async RequestPartToWarehouse(id: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/${id}/requestPart`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para pedir peça ao armazém",
        null
      );
    }
  }

  async SelectPartToWarehouse(
    id: number,
    data: AssistancePartRequestWarehouse
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/${id}/selectPart`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para selecionar peça",
        null
      );
    }
  }

  async GetRequestedParts(
    data: PaginatedPartListDTO
  ): Promise<PaginatedList<AssistancePartListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetRequestedPartsToWarehouse`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<AssistancePartListDTO>(
        false,
        "Erro ao obter a informação das peças pedidas a armazém",
        "",
        [],
        0
      );
    }
  }

  async GetSelectedParts(
    data: PaginatedPartListDTO
  ): Promise<PaginatedList<AssistancePartListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetSelectedPartsToWarehouse`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<AssistancePartListDTO>(
        false,
        "Erro ao obter a informação das peças selecionadas",
        "",
        [],
        0
      );
    }
  }

  async UsePart(assistancePartId: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/UsePart`,
        {
          assistancePartId,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao utilizar a peça",
        null
      );
    }
  }

  async UseAllParts(id: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/${id}/useAllParts`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao utilizar todas as peças",
        null
      );
    }
  }

  async AddPartToAssistance(
    data: AddPartToAssistanceDTO,
    id: string
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/AddPartToAssistance?id=${id}`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao adicionar a peça à assistência",
        null
      );
    }
  }

  async RemovePartFromAssistance(id: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().delete(
        `${APIService.GetURL()}/Assistance/RemovePartFromAssistance/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao remover a peça da assistência",
        null
      );
    }
  }

  async GetDebtHours(
    data: GetPaginatedDebtHoursDTO
  ): Promise<PaginatedList<GetDebtHoursDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetDebtHours`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<GetDebtHoursDTO>(
        false,
        "Erro ao obter as horas debitadas",
        "",
        [],
        0
      );
    }
  }

  async GetFiles(
    data: GetPaginatedFileListDTO
  ): Promise<PaginatedList<GetFileDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetFiles`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<GetFileDTO>(
        false,
        "Erro ao obter os ficheiros",
        "",
        [],
        0
      );
    }
  }

  async GetFilesMetadata(
    data: GetPaginatedFileListDTO
  ): Promise<PaginatedList<GetFileMetadataDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetFilesMetadata`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<GetFileMetadataDTO>(
        false,
        "Erro ao obter os ficheiros",
        "",
        [],
        0
      );
    }
  }

  async DownloadSingleFile(fileId: number): Promise<MessagingHelper<GetFileDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/DownloadSingleFile?fileId=${fileId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<GetFileDTO | null>(
        false,
        "Erro ao fazer download o ficheiro",
        null
      );
    }
  }

  async StreamFile(fileId: number): Promise<Blob> {
    const response = await APIService.Axios().get(
      `${APIService.GetURL()}/Assistance/StreamFile?fileId=${fileId}`,
      {
        headers: {
          Authorization: "Bearer " + APIService.GetToken(),
        },
        responseType: "blob",
      }
    );
    return response.data;
  }

  async GetAllFilesFromAssistance(
    assistanceId: number
  ): Promise<MessagingHelper<GetFileDTO[]>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/assistance/GetAllFilesFromAssistance/${assistanceId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<GetFileDTO[]>(
        false,
        "Erro ao obter os ficheiros da assistência",
        []
      );
    }
  }

  async InsertFile(
    file: File,
    assistanceId: number,
    fileTypeId: string,
    notes: string
  ): Promise<MessagingHelper<null>> {
    try {
      const formData = new FormData();
      formData.append("File", file, file.name);
      formData.append("FileTypeId", fileTypeId);
      formData.append("Notes", notes);

      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/assistance/${assistanceId}/AddFile`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao adicionar ficheiro",
        null
      );
    }
  }

  async RemoveFile(id: number, idFile: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().delete(
        `${APIService.GetURL()}/Assistance/${id}/DeleteFile/${idFile}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao remover o ficheiro",
        null
      );
    }
  }



  async GetExternalAssistances(
    data: GetPaginatedExternalAssistancesDTO
  ): Promise<PaginatedList<GetExternalAssistancesDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetExternalAssistances`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<GetExternalAssistancesDTO>(
        false,
        "Erro ao obter as horas debitadas na assistência externa",
        "",
        [],
        0
      );
    }
  }

  async InsertExternalHours(
    validExtraHour: InsertExternalHoursDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/InsertExternalHours`,
        {
          ...validExtraHour,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao registar as horas extras",
        null
      );
    }
  }

  async ValidExternalHours(
    validExtraHour: ValidExternalHoursDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/ValidExternalHours`,
        {
          ...validExtraHour,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao registar as horas extras",
        null
      );
    }
  }

  async InsertOrUpdateTechnician(
    data: EditTechnicianFromAssistanceDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/InsertOrUpdateTechnician`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao atribuir o técnico á assistência",
        null
      );
    }
  }

  async RemoveSelectedPart(id: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().delete(
        `${APIService.GetURL()}/Part/RemoveSelectedPart/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao remover a peça da assistência",
        null
      );
    }
  }

  async ConcludeAssistance(
    assistanceId: number
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/ConcludeAssistance/${assistanceId}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao concluir a assistência",
        null
      );
    }
  }

  async GetAssistancesFromEquipment(
    search: GetAssistanceFromEquipmentDTO
  ): Promise<PaginatedList<AssistanceListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetAssistancesFromEquipment`,
        {
          ...search,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<AssistanceListDTO>(
        false,
        "Ocorreu um erro ao obter as assistências do Equipamento",
        "",
        [],
        0
      );
    }
  }

  async GetStatusHistory(
    data: GetStatusPaginatedDTO
  ): Promise<PaginatedList<GetStatusHistoryDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetStatusHistory`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<GetStatusHistoryDTO>(
        false,
        "Ocorreu um erro ao obter o histórico dos estados da assistência",
        "",
        [],
        0
      );
    }
  }

  async ConcludeAssistanceBackoffice(
    assistanceId: number
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/${assistanceId}/ConcludeAssistanceBackoffice`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao concluir a assistência",
        null
      );
    }
  }

  async ReopenAssistence(assistanceId: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/${assistanceId}/ReopenAssistance`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao reabrir a assistência",
        null
      );
    }
  }

  async GetPossibleStatus(
    assistanceId: number
  ): Promise<MessagingHelper<StatusDTO[]>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/possibleStatus/${assistanceId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<StatusDTO[]>(
        false,
        "Erro ao obter os estados possíveis",
        []
      );
    }
  }

  async AddNewStatus(data: AddNewStatusDTO): Promise<MessagingHelper<AddNewStatusDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/AddNewStatus`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<any>(
        false,
        "Ocorreu um erro ao alterar o estado da assistência",
        null
      );
    }
  }

  async GeneratePDF(data: GetAssistanceDTO): Promise<MessagingHelper<string>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GeneratePDF`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<any>(
        false,
        "Erro ao enviar pedido para gerar o  PDF",
        null
      );
    }
  }

  async CreateFabrication(
    data: CreateFabricationDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/CreateFabrication`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<any>(
        false,
        "Ocorreu um erro ao criar a fabricação",
        null
      );
    }
  }

  async GetStockEntryDocumentErpId(
    assistanceId: number
  ): Promise<MessagingHelper<any>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/GetStockEntryDocumentErpId/${assistanceId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<any>(
        false,
        "Erro ao obter o valor do campo StockEntryDocumentErpId",
        null
      );
    }
  }

  async SetBillableAssistancePart(
    id: number,
    billable: boolean
  ): Promise<MessagingHelper<null>> {
    try {
      const response = await APIService.Axios().put(
        `${APIService.GetURL()}/Assistance/SetBillableAssistancePart/${id}?billable=${billable}`,
        null,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao atualizar a propriedade",
        null
      );
    }
  }

  //rentabilidade
  async GetAssistanceProfitability(
    assistanceId: number,
    data: AssistanceProfitabilityParametersDTO
  ): Promise<MessagingHelper<AssistanceProfitabilityDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/GetAssistanceProfitability/${assistanceId}`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<any>(
        false,
        "Erro ao obter a rentabilidade da assistência",
        null
      );
    }
  }

  async SubmitDigitalSignature(
    id: number,
    data: DigitalSignatureDTO
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/DigitalSignature/${id}`,
        {
          ...data,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao submeter assinatura",
        null
      );
    }
  }

  async ClearDigitalSignature(
    id: number
  ): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().delete(
        `${APIService.GetURL()}/Assistance/ClearDigitalSignature/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Ocorreu um erro ao ligar ao servidor para limpar a assinatura",
        null
      );
    }
  }

  async GetBySubcontractorCompanyName(
    searchParams: SearchBySubcontractorCompanyNameDTO,
  ): Promise<MessagingHelper<TechnicianDTO[] | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/technician/GetBySubcontractorCompanyName`,
        {
          ...searchParams,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        },
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para obter os técnicos da empresa selecionada",
        null
      );
    }
  }

  async RemoveExternalAssistanceFromAssistance(id: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().delete(
        `${APIService.GetURL()}/Assistance/RemoveExternalAssistanceFromAssistance/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao remover a assistência externa da assistência",
        null
      );
    }
  }

  async GetAssistanceRecall(id: Number): Promise<MessagingHelper<AssistanceRecallDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/RecallDetailsFromAssistance/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceRecallDTO | null>(
        false,
        "Erro ao ligar ao servidor para obter a campanha da assistência",
        null
      );
    }
  }

  async EditAssistanceRecall(warranty: EditAssistanceRecallDTO): Promise<MessagingHelper<AssistanceRecallDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/EditRecallFromAssistance`,
        { ...warranty },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceRecallDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação da campanha da assistencia",
        null
      );
    }
  }

  async GetAssistanceWarranty(id: Number): Promise<MessagingHelper<AssistanceWarrantyDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/WarrantyDetailsFromAssistance/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceWarrantyDTO | null>(
        false,
        "Erro ao ligar ao servidor para obter a garantia da assistência",
        null
      );
    }
  }
  async EditAssistanceWarranty(warranty: EditAssistanceWarrantyDTO): Promise<MessagingHelper<AssistanceWarrantyDTO | null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/EditWarrantyFromAssistance`,
        { ...warranty },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceWarrantyDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação da garantia da assistencia",
        null
      );
    }
  }

  async GetAssistanceLoanEquipment(id: Number): Promise<MessagingHelper<AssistanceLoanEquipmentDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/GetEquipmentLoan/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceLoanEquipmentDTO | null>(
        false,
        "Erro ao ligar ao servidor para obter o equipamento de empréstimo da assistência",
        null
      );
    }
  }

  async EditAssistanceLoanEquipment(loanEquipment: EditAssistanceLoanEquipmentDTO): Promise<MessagingHelper<AssistanceLoanEquipmentDTO | null>> {
    try {
      var response = await APIService.Axios().put(
        `${APIService.GetURL()}/Assistance/UpdateEquipmentLoan`,
        { ...loanEquipment },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AssistanceLoanEquipmentDTO | null>(
        false,
        "Erro ao ligar ao servidor para atualizar a informação do equipamento de empréstimo da assistencia",
        null
      );
    }
  }

  async GetCanonSummaryData(assistanceId: number): Promise<MessagingHelper<CanonSummaryDataDTO | null>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/Assistance/${assistanceId}/CanonSummaryData`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<CanonSummaryDataDTO | null>(
        false,
        "Erro ao ligar ao servidor para obter os dados do resumo Canon",
        null
      );
    }
  }

  async SendCanonSummaryEmail(assistanceId: number): Promise<MessagingHelper<null>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/Assistance/${assistanceId}/SendCanonSummaryEmail`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao ligar ao servidor para enviar o email do resumo Canon",
        null
      );
    }
  }

}
